export default "__VITE_ASSET__Dvjh_DUR__"